import { render, staticRenderFns } from "./ShareableLink.vue?vue&type=template&id=4b880486&scoped=true&"
import script from "./ShareableLink.vue?vue&type=script&lang=js&"
export * from "./ShareableLink.vue?vue&type=script&lang=js&"
import style0 from "./ShareableLink.vue?vue&type=style&index=0&id=4b880486&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b880486",
  null
  
)

/* custom blocks */
import block0 from "./ShareableLink.vue?vue&type=custom&index=0&blockType=i18n&locale=en&lang=yaml"
if (typeof block0 === 'function') block0(component)
import block1 from "./ShareableLink.vue?vue&type=custom&index=1&blockType=i18n&locale=ru&lang=yaml"
if (typeof block1 === 'function') block1(component)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VTextarea } from 'vuetify/lib/components/VTextarea';
installComponents(component, {VCardText,VForm,VIcon,VTextarea})
